import { useQuery } from "../shared/hooks/use-query"
import { Link } from "react-router-dom";
import { getGameByTitle } from "../shared/services/game.service";

export function Play() {
    const gameQueryParameter = useQuery().get('game');
    const gameTitle = gameQueryParameter? gameQueryParameter: '';
    const game = getGameByTitle(gameTitle);

    return <div className="flexHorizontal flexJustifyCenter flexAllignCenter height80vh">
        <iframe 
            title={gameTitle}            
            src={game.embeddedLink} 
            width="90%"
            height="80%"
            allowFullScreen={true}
            >
                <Link to={`/external-redirect?url=${encodeURIComponent(game.link)}`}>Play {game.title} on itch.io</Link>
            </iframe>
    </div>
}